// Browser client for the waitlist, talking to our own Next.js route handlers
// (which proxy to the NestJS API). No direct API origin in the browser.

export interface WaitlistStatus {
  status: "pending" | "confirmed" | "closed";
  enabled: boolean;
  granted?: boolean;
  id?: string;
  token?: string;
  position?: number;
  total?: number;
  confirmedReferrals?: number;
  spotsGained?: number;
  refLink?: string;
  rewardTop?: number;
  inTop?: boolean;
}

async function jpost<T>(path: string, body: unknown): Promise<T> {
  const r = await fetch(`/api/waitlist/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = (await r.json().catch(() => ({}))) as T & { message?: string };
  if (!r.ok) throw new Error(data?.message ?? `HTTP ${r.status}`);
  return data;
}

async function jget<T>(path: string): Promise<T> {
  const r = await fetch(`/api/waitlist/${path}`);
  const data = (await r.json().catch(() => ({}))) as T & { message?: string };
  if (!r.ok) throw new Error(data?.message ?? `HTTP ${r.status}`);
  return data;
}

export const waitlistApi = {
  signup: (email: string, ref?: string) =>
    jpost<{ status: "pending" | "confirmed" | "closed"; enabled: boolean }>("signup", { email, ref }),
  confirm: (token: string) => jpost<WaitlistStatus>("confirm", { token }),
  me: (token: string) => jget<WaitlistStatus>(`me?token=${encodeURIComponent(token)}`),
  count: () => jget<{ count: number }>("count"),
  config: () => jget<{ enabled: boolean; count: number }>("config"),
};
